import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchHospitalCaseStageCount } from "../../redux/hospitalDetailsSlice";
import { CaseServices } from "../../services/CaseServices";
import { HospitalServices } from "../../services/HospitalServices";
import { logOut, getUser } from "../../config/user";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import PreinitiateModal from "../../dashboard/cases/preInitiateModal/PreinitiateModal";
import { Link } from "react-router-dom";
import UploadAdmissionInitiateRefDoc from "./hospitalReferenceDocument/UploadAdmissionInitiateRefDoc";
import HospitalReferenceDocument from "./hospitalReferenceDocument/HospitalReferenceDocument";
import HospitalCustomPaginaion from "../../utils/HospitalPaginationUtil";
import EnhancementFormHospitalPersona from "./enhancement/EnhancementFormHospitalPersona";
import DialysisEnhancementFormHospitalPersona from "./enhancement/DialysisEnhancementFormHospitalPersona";
import TpaEnhancementFormHospitalPersona from "./enhancement/TpaEnhancementFormHospitalPersona";
import DischargeFormHospitalPersona from "./discharge/DischargeFormHospitalPersona";
import TpaDischargeFormHospitalPersona from "./discharge/TpaDischargeFormHospitalPersona";
import TpaUploadReferenceDocModal from "./hospitalReferenceDocument/TpaUploadReferenceDocModal";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { CircularProgress } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SearchIcon from "../../assets/searchIcon.svg";
import CallIcon from "../../assets/call filled.svg";
import ChatIcon from "../../assets/chat.svg";
import downIcon from "../../assets/downLatestArrow.svg";
import UploadIcon from "../../assets/upload.svg";
import GoToIcon from "../../assets/arrow-right.svg";
import UnreadCheck from "../../assets/preApprovedUnread.svg";
import ReadCheck from "../../assets/preApprovedRead.svg";
import RejectedUnread from "../../assets/preRejectedUnread.svg";
import RiskIcon from "../../assets/riskIcon.svg";
import ReferenceRejected from "../../assets/rejectedReferenceIcon.svg";
import HighPriorityIcon from "../../assets/highPriority.svg";
import InitiateAdmission from "../../hospitaldashboard/InitiateAdmission/InitiateAdmission";
import ReferenceNotUploadedModal from "./ReferenceNotUploadedModal";
import AddPatientModal from "./addPatient/AddPatientModal";
import { selectedTab } from "../../redux/roleSlice";
import { updateSelectedHsaScheme } from "../../redux/caseDetailsSlice";
import { toast } from "react-toastify";
import CloseIcon from "../../assets/hospitalCloseIcon.svg";
import Select, { components } from "react-select";
import OutTimeModal from "./outTime/OutTimeModal";
import CountdownTimer from "../../utils/countDownTimer";

const SCHEME_OPTIONS = [
  { value: "PMJAY", label: "PMJAY" },
  { value: "CGHS", label: "CGHS" },
  { value: "TPA", label: "TPA/PAYER" },
];

const CaseStatus = () => {
  const [caseList, setCaseList] = useState(null);
  const [caseType, setCaseType] = useState("");
  const [stayDuration, setStayDuration] = useState("");
  const [stratification, setStratification] = useState("");
  const [subType, setSubType] = useState("");
  const [admissionDate, setAdmissionDate] = useState("");
  const [surgeryTreatmentStartDate, setSurgeryTreatmentStartDate] =
    useState("");
  const [subTypeOptions, setSubTypeOptions] = useState([]);
  const [loading, setIsLoading] = useState(false);
  const [stageUpdating, setStageUpdating] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addDischarge, setAddDischarge] = useState(false);
  const [addEnhancement, setAddEnhancement] = useState(false);
  const [openOutTimeModal, setOpenOutTimeModal] = useState(false);
  const [expanded, setExpanded] = useState({ id: "", expand: "false" });
  const [selectedCase, setSelectedCase] = useState(null);
  const [openReferenceModal, setOpenReferenceModal] = useState(false);
  const [referenceNotUploaded, setReferenceNotUploaded] = useState(null);
  const [openInitiateReferenceModal, setOpenInitiateReferenceModal] =
    useState(false);
  const [openTpaEnhancementUpload, setOpenTpaEnhancementUpload] =
    useState(false);
  const [tpaEnhancementFormData, setTpaEnhancementFormData] = useState(null);
  const [openTpaDischargeUpload, setOpenTpaDischargeUpload] = useState(false);
  const [tpaDischargeFormData, setTpaDischargeFormData] = useState(null);
  const [caseStageCount, setCaseStageCount] = useState(null);
  const [stageType, setStageType] = useState("");
  const [caseProcedures, setCaseProcedures] = useState([]);
  const [enhancementList, setEnhancementList] = useState([]);
  const [openAddPatientModal, setOpenAddPatientModal] = useState(false);
  const [addPatientFiles, setAddPatientFiles] = useState([]);

  const options = SCHEME_OPTIONS;
  const dispatch = useDispatch();
  const { caseId, searchKey, selectedHsaScheme } = useSelector(
    (store) => store.caseDetails,
  );
  const [selectedScheme, setSelectedScheme] = useState(() => {
    const saved = SCHEME_OPTIONS.find(
      (opt) => opt.value === selectedHsaScheme,
    );
    return saved || SCHEME_OPTIONS[0];
  });

  const [subStageType, setSubStageType] = useState("");
  const { messageId } = useSelector((store) => store.notificationReducer);
  const hospitalId = getUser()?.hospital?.id;
  const limit = 10;
  const navigate = useNavigate();
  const location = useLocation();

  const calculatePrcentage = (uploaded, total) => {
    let percent = 0;
    if (total !== 0) {
      percent = (uploaded / total) * 100;
    }
    return percent;
  };
  const handleClearAllClick = () => {
    setSubStageType("");
  };
  const getDate = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <img src={downIcon} alt="down-arrow" className="w-[18px] h-[18px]" />
    </components.DropdownIndicator>
  );

  // const handleSearch = (e) => {
  //   const value = e.target.value.trim();

  //   // debouncing structure
  //   if (searchTimeRef.current) {
  //     clearTimeout(searchTimeRef.current);
  //   }

  //   searchTimeRef.current = setTimeout(() => {
  //     setSearchKey(value);
  //     setPage(1);
  //     setPage(1);
  //   }, 500);
  // };

  const handleInitiateEnhancement = async (caseItem) => {
    setStageUpdating(caseItem?.id);

    try {
      // Fetch enhancement list and case procedures with the current case ID
      const [enhancementsResponse, proceduresResponse] = await Promise.all([
        CaseServices.getEnhancementsList(caseItem.id),
        CaseServices.getCaseProcedures(caseItem.id),
      ]);

      // Prepare enriched case data by adding fetched enhancements & procedures
      const enrichedCase = {
        ...caseItem,
        enhancements: enhancementsResponse.data.enhancements,
        procedures: proceduresResponse.data.caseProcedures,
      };

      // Update selectedCase and open modal
      setSelectedCase(enrichedCase);
      setAddEnhancement(true);
    } catch (error) {
      handleApiErrorResponses(error);
    }

    setStageUpdating(null);
  };

  const handleInitiateAdmission = async (caseItem) => {
    setStageUpdating(caseItem?.id);
    if (caseItem?.totalReferenceDocuments) {
      try {
        await CaseServices.initiateAdmission(caseItem?.id);
        toast.success("Admission Initiated");

        await refreshDashboardData();
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      setSelectedCase(caseItem);
      setReferenceNotUploaded(caseItem.id);
    }
    setStageUpdating(null);
  };
  const getHospitalCaseStageCount = async () => {
    try {
      const res = await HospitalServices.getHospitalStageCaseCount(hospitalId);

      setCaseStageCount(res.data);
      dispatch(fetchHospitalCaseStageCount(hospitalId));

      return res.data;
    } catch (error) {
      handleApiErrorResponses(error);
      return null;
    }
  };
  const getPendingDocuments = (caseItem) => {
    if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("admission") &&
      (caseItem?.admissionDocumentsPending ||
        caseItem?.admissionDocumentsRejected)
    ) {
      return (
        caseItem?.admissionDocumentsPending +
        caseItem?.admissionDocumentsRejected
      );
    } else if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("enhancement") &&
      (caseItem?.latestEnhancementPending ||
        caseItem?.latestEnhancementRejected)
    ) {
      return (
        caseItem?.latestEnhancementPending + caseItem?.latestEnhancementRejected
      );
    } else if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("claim") &&
      (caseItem?.onDischargePending || caseItem?.onDischargeRejected)
    ) {
      return (
        Number(caseItem?.onDischargePending) +
        Number(caseItem?.onDischargeRejected)
      );
    } else {
      return "";
    }
  };
  const getTotalDocuments = (caseItem) => {
    if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("admission")
    ) {
      return caseItem?.totalAdmissionDocuments;
    } else if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("enhancement")
    ) {
      return caseItem?.totalLatestEnhancementDocuments;
    } else if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("claim")
    ) {
      return caseItem?.totalOnDischargeDocuments;
    } else {
      return "";
    }
  };
  const getRejectedDocuments = (caseItem) => {
    if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("admission")
    ) {
      return caseItem?.admissionDocumentsRejected;
    } else if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("enhancement")
    ) {
      return caseItem?.latestEnhancementRejected;
    } else if (
      caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("claim")
    ) {
      return caseItem?.onDischargeRejected;
    } else {
      return "";
    }
  };
  const getFormattedAge = (birthDate) => {
    if (!birthDate) return "";
    const today = new Date();
    const birthDateObj = new Date(birthDate);

    let years = today.getFullYear() - birthDateObj.getFullYear();
    let months = today.getMonth() - birthDateObj.getMonth();
    let days = today.getDate() - birthDateObj.getDate();

    if (days < 0) {
      months -= 1;
      // Get the number of days in the previous month
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    let ageStr = "";
    if (years > 0) ageStr += `${years}yr`;
    if (months > 0) ageStr += `${months}m`;
    if (days > 0) ageStr += `${days}d`;
    if (!ageStr) ageStr = "0d";
    return ageStr;
  };
  const refreshDashboardData = async () => {
    const isTpa = selectedScheme.value === "TPA" ? 1 : 0;
    try {
      const updatedCounts = await HospitalServices.getHospitalStageCaseCount(
        hospitalId,
        isTpa,
      );

      const latestCounts = updatedCounts.data;

      setCaseStageCount({ ...latestCounts });

      dispatch(fetchHospitalCaseStageCount(hospitalId));

      await AllCases(latestCounts);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const AllCases = async (latestCounts = caseStageCount) => {
    try {
      setIsLoading(true);
      let hsaStages = [];
      if (stageType) {
        hsaStages =
          latestCounts && subStageType
            ? latestCounts[`total${stageType}CountNew`][`${subStageType}`]
                ?.stages
            : "";
      } else {
        hsaStages =
          latestCounts && subStageType
            ? [
                ...latestCounts[`totalAdmissionCountNew`][`${subStageType}`]
                  ?.stages,
                ...latestCounts[`totalEnhancementCountNew`][`${subStageType}`]
                  ?.stages,
                ...latestCounts[`totalDischargeCountNew`][`${subStageType}`]
                  ?.stages,
                ...latestCounts[`totalClaimCountNew`][`${subStageType}`]
                  ?.stages,
              ]
            : "";
      }
      const dialysisHsaStages = [
        "Admission Dialysis on Out",
        "Enhancement Dialysis on Out",
      ];
      const isTpa = selectedScheme.value === "TPA" ? 1 : 0;
      const res = await HospitalServices.getHospitalCases(
        searchKey ?? "",
        page,
        limit,
        "",
        hsaStages?.length > 0 ? "" : stageType + subStageType,
        location.pathname?.includes("dialysis") ? dialysisHsaStages : hsaStages,
        isTpa,
      );

      setCaseList(res.data.caseList);
      setTotalPages(res?.data?.totalPages);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);

      handleApiErrorResponses(error);
    }
  };
  const handleOutTimeStageUpdate = async (caseItem) => {
    const postStageData = {
      commandCeneterStage: caseItem?.submasterstagestatuses[0]?.hsaStage
        ?.toLowerCase()
        ?.includes("admission")
        ? "Admission Dialysis on Out"
        : "Enhancement Dialysis on Out",
      dialysisInTime: new Date().toISOString(),
      dialysisOutTime: new Date(Date.now() + 3 * 60 * 60 * 1000).toISOString(),
    };

    try {
      const res = await CaseServices.updateSubMasterStage(
        caseItem.id,
        postStageData,
      );
      toast.success(res?.data?.message);
      await refreshDashboardData();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    refreshDashboardData();

    window.addEventListener("resize", updateDimensions);

    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);
  useEffect(() => {
    AllCases();
  }, [
    page,
    searchKey,
    stageType,
    subStageType,
    caseId,
    messageId,
    selectedScheme,
  ]);

  // Persist scheme filter (same idea as CC active-cases isTpa) until user changes it
  useEffect(() => {
    dispatch(updateSelectedHsaScheme(selectedScheme?.value || ""));
  }, [selectedScheme, dispatch]);

  useEffect(() => {
    setPage(1);
  }, [searchKey]);

  //testing push

  return (
    <div>
      <div
        style={{ color: "rgba(0,0,0,0.5)" }}
        className="text-[11px] 2xl:text-sm leading-[18.27px] -tracking-[3%] cursor-pointer"
      >
        <span onClick={() => navigate("/")}>Home</span> / Case Status /{" "}
        {stageType === ""
          ? "All"
          : stageType?.includes("Reprocess")
            ? "Reprocess Claim"
            : stageType?.includes("Erroneous")
              ? "Erroneous Claim"
              : stageType}
      </div>

      <div className=" flex items-center justify-between mt-[24px] 2xl:mt-[30px]">
        {location.pathname.includes("dialysis") ? (
          <div />
        ) : (
          <div
            style={{ background: "rgba(255,255,255,0.5)" }}
            className="w-fit text-[11px] 2xl:text-sm leading-[18.27px] -tracking-[3%] flex gap-[24px] 2xl:gap-[30px] items-center py-3 2xl:py-4 px-4 2xl:px-5  rounded-full"
          >
            <div className="flex items-center">
              <input
                type="radio"
                name="type"
                id="all"
                value={""}
                checked={stageType === ""}
                onChange={(e) => {
                  setStageType(e.target.value);
                  setSubStageType("");
                  setPage(1);
                }}
              />
              <label htmlFor="all" className="ml-[5px]">
                All
              </label>
              <div className="ml-[10px]">
                {" "}
                {caseStageCount?.overallTotalCount?.total}
              </div>
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                name="type"
                id="admission"
                value={"Admission"}
                onChange={(e) => {
                  const selectedStage = e.target.value;

                  setStageType(selectedStage);
                  setSubStageType("");
                  setPage(1);
                }}
              />
              <label htmlFor="admission" className="ml-[5px]">
                Admission
              </label>
              <div className="ml-[10px]">
                {caseStageCount?.totalAdmissionCountNew?.total || 0}
              </div>
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                name="type"
                id="enhancement"
                value={"Enhancement"}
                onChange={(e) => {
                  const selectedStage = e.target.value;

                  setStageType(selectedStage);
                  setSubStageType("");
                  setPage(1);
                }}
              />
              <label htmlFor="enhancement" className="ml-[5px]">
                Enhancement
              </label>
              <div className="ml-[10px]">
                {caseStageCount?.totalEnhancementCountNew?.total || 0}
              </div>{" "}
            </div>

            <div className="flex items-center">
              <input
                type="radio"
                name="type"
                id="claim"
                value={"Claim"}
                onChange={(e) => {
                  const selectedStage = e.target.value;

                  setStageType(selectedStage);
                  setSubStageType("");
                  setPage(1);
                }}
              />
              <label htmlFor="claim" className="ml-[5px]">
                Discharge/Claim
              </label>
              <div className="ml-[10px]">
                {" "}
                {caseStageCount?.totalClaimCountNew?.total || 0}
              </div>{" "}
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                name="type"
                id="claimErroneous"
                value={"ClaimErroneous"}
                onChange={(e) => {
                  const selectedStage = e.target.value;

                  setStageType(selectedStage);
                  setSubStageType("");
                  setPage(1);
                }}
              />
              <label htmlFor="claimErroneous" className="ml-[5px]">
                Erroneous Claim
              </label>
              <div className="ml-[10px]">
                {" "}
                {caseStageCount?.totalClaimErroneousCountNew?.total || 0}
              </div>{" "}
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                name="type"
                id="claimReprocess"
                value={"ClaimReprocess"}
                onChange={(e) => {
                  const selectedStage = e.target.value;

                  setStageType(selectedStage);
                  setSubStageType("");
                  setPage(1);
                }}
              />
              <label htmlFor="claimReprocess" className="ml-[5px]">
                Reprocess Claim
              </label>
              <div className="ml-[10px]">
                {" "}
                {caseStageCount?.totalClaimReprocessCountNew?.total || 0}
              </div>{" "}
            </div>
          </div>
        )}
        <Select
          value={selectedScheme}
          onChange={(scheme) => {
            const next = scheme || SCHEME_OPTIONS[0];
            setSelectedScheme(next);
            dispatch(updateSelectedHsaScheme(next?.value || ""));
            if (next?.value !== "TPA") {
              setOpenAddPatientModal(false);
              setAddPatientFiles([]);
            }
          }}
          options={options}
          isSearchable={false}
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator,
          }}
          styles={{
            control: (base) => ({
              ...base,
              width: 144,
              minHeight: 52,
              height: 52,
              backgroundColor: "#FFFFFF99",
              border: "1px solid #017C71",
              borderRadius: 999,
              boxShadow: "none",
              cursor: "pointer",
              paddingLeft: 6,
              paddingRight: 6,
            }),
            valueContainer: (base) => ({
              ...base,
              padding: "0 12px",
            }),
            singleValue: (base) => ({
              ...base,
              fontFamily: "Lufga",
              fontSize: "14px",
              fontWeight: 400,
              color: "#1B1B1B",
              letterSpacing: "-0.03em",
            }),
            placeholder: (base) => ({
              ...base,
              fontFamily: "Lufga",
              fontSize: "14px",
              color: "#1B1B1B",
            }),
            menu: (base) => ({
              ...base,
              borderRadius: 20,
              overflow: "hidden",
              zIndex: 9999,
            }),
            menuList: (base) => ({
              ...base,
              padding: 0,
            }),
            option: (base, state) => ({
              ...base,
              fontFamily: "Lufga",
              fontSize: "14px",
              backgroundColor: state.isFocused ? "#F5F5F5" : "#FFFFFF",
              color: "#1B1B1B",
              cursor: "pointer",
            }),
          }}
        />
      </div>

      <div
        id="case-list"
        style={{ background: "rgba(255,255,255,0.5)" }}
        className="p-4 2xl:p-8 mt-4 rounded-[30px]"
      >
        <div className="w-full flex items-center justify-between ">
          <div className="text-[30px] 3xl:text-[50px]   -tracking-[0.07em]">
            {stageType === ""
              ? "All"
              : stageType?.includes("Reprocess")
                ? "Reprocess Claim"
                : stageType?.includes("Erroneous")
                  ? "Erroneous Claim"
                  : stageType}
          </div>

          {!location.pathname.includes("dialysis") && (
            <div className="flex text-[11px] 2xl:text-sm leading-[18.27px] -tracking-[0.03em] items-center gap-[8px] 2xl:gap-[30px]">
              <div
                style={{ background: "rgba(255,255,255,0.5)" }}
                className="w-fit flex gap-[10px] 2xl:gap-[16px] 3xl:gap-[30px] items-center flex-wrap justify-end py-3 2xl:py-4 px-4 2xl:px-5 rounded-full"
              >
                <div className="w-fit flex gap-[12px] items-center  bg-[#E4E4E4]  rounded-full py-1 px-2">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      name="status"
                      id="initiate"
                      value={"Initiate"}
                      checked={subStageType.includes("Initiate")}
                      onChange={(e) => {
                        setSubStageType(e.target.value);
                        setPage(1);
                      }}
                    />
                    <label htmlFor="initiate" className="ml-[5px]">
                      Initiate
                    </label>
                    <div className="ml-[10px]">
                      {" "}
                      {stageType.includes("Admission")
                        ? caseStageCount?.totalAdmissionCountNew?.Initiate
                            ?.count
                        : stageType.includes("Enhancement")
                          ? caseStageCount?.totalEnhancementCountNew?.Initiate
                              ?.count
                          : stageType.includes("Discharge")
                            ? caseStageCount?.totalDischargeCountNew?.Initiate
                                ?.count
                            : stageType.includes("Claim") &&
                                !stageType.includes("Erroneous") &&
                                !stageType.includes("Reprocess")
                              ? caseStageCount?.totalClaimCountNew?.Initiate
                                  ?.count
                              : stageType.includes("ClaimErroneous")
                                ? caseStageCount?.totalClaimErroneousCountNew
                                    ?.Initiate?.count
                                : stageType.includes("ClaimReprocess")
                                  ? caseStageCount?.totalClaimReprocessCountNew
                                      ?.Initiate?.count
                                  : caseStageCount?.overallTotalCount?.Initiate}
                    </div>{" "}
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      name="status"
                      id="pending"
                      value={"Pending"}
                      checked={subStageType.includes("Pending")}
                      onChange={(e) => {
                        setSubStageType(e.target.value);
                        setPage(1);
                      }}
                    />
                    <label htmlFor="pending" className="ml-[5px]">
                      Pending
                    </label>
                    <div className="ml-[10px]">
                      {" "}
                      {stageType.includes("Admission")
                        ? caseStageCount?.totalAdmissionCountNew?.Pending?.count
                        : stageType.includes("Enhancement")
                          ? caseStageCount?.totalEnhancementCountNew?.Pending
                              ?.count
                          : stageType.includes("Discharge")
                            ? caseStageCount?.totalDischargeCountNew?.Pending
                                ?.count
                            : stageType.includes("Claim") &&
                                !stageType.includes("Erroneous") &&
                                !stageType.includes("Reprocess")
                              ? caseStageCount?.totalClaimCountNew?.Pending
                                  ?.count
                              : stageType.includes("ClaimErroneous")
                                ? caseStageCount?.totalClaimErroneousCountNew
                                    ?.Pending?.count
                                : stageType.includes("ClaimReprocess")
                                  ? caseStageCount?.totalClaimReprocessCountNew
                                      ?.Pending?.count
                                  : caseStageCount?.overallTotalCount?.Pending}
                    </div>{" "}
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      name="status"
                      id="rejected"
                      value={"Rejected"}
                      checked={subStageType.includes("Rejected")}
                      onChange={(e) => {
                        setSubStageType(e.target.value);
                        setPage(1);
                      }}
                    />
                    <label htmlFor="rejected" className="ml-[5px]">
                      Docs Denied
                    </label>
                    <div className="ml-[10px]">
                      {" "}
                      {stageType.includes("Admission")
                        ? caseStageCount?.totalAdmissionCountNew?.Rejected
                            ?.count
                        : stageType.includes("Enhancement")
                          ? caseStageCount?.totalEnhancementCountNew?.Rejected
                              ?.count
                          : stageType.includes("Discharge")
                            ? caseStageCount?.totalDischargeCountNew?.Rejected
                                ?.count
                            : stageType.includes("Claim") &&
                                !stageType.includes("Erroneous") &&
                                !stageType.includes("Reprocess")
                              ? caseStageCount?.totalClaimCountNew?.Rejected
                                  ?.count
                              : stageType.includes("ClaimErroneous")
                                ? caseStageCount?.totalClaimErroneousCountNew
                                    ?.Rejected?.count
                                : stageType.includes("ClaimReprocess")
                                  ? caseStageCount?.totalClaimReprocessCountNew
                                      ?.Rejected?.count
                                  : caseStageCount?.overallTotalCount?.Rejected}
                    </div>
                  </div>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="status"
                    id="inProgress"
                    value={"Progress"}
                    checked={subStageType.includes("Progress")}
                    onChange={(e) => {
                      setSubStageType(e.target.value);
                      setPage(1);
                    }}
                  />
                  <label
                    htmlFor="inProgress"
                    className="ml-[5px] text-nowrap whitespace-nowrap"
                  >
                    In Progress
                  </label>
                  <div className="ml-[10px]">
                    {" "}
                    {stageType.includes("Admission")
                      ? caseStageCount?.totalAdmissionCountNew?.Progress?.count
                      : stageType.includes("Enhancement")
                        ? caseStageCount?.totalEnhancementCountNew?.Progress
                            ?.count
                        : stageType.includes("Discharge")
                          ? caseStageCount?.totalDischargeCountNew?.Progress
                              ?.count
                          : stageType.includes("Claim") &&
                              !stageType.includes("Erroneous") &&
                              !stageType.includes("Reprocess")
                            ? caseStageCount?.totalClaimCountNew?.Progress
                                ?.count
                            : stageType.includes("ClaimErroneous")
                              ? caseStageCount?.totalClaimErroneousCountNew
                                  ?.Progress?.count
                              : stageType.includes("ClaimReprocess")
                                ? caseStageCount?.totalClaimReprocessCountNew
                                    ?.Progress?.count
                                : caseStageCount?.overallTotalCount?.Progress}
                  </div>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="status"
                    id="submitted"
                    value={"Submitted"}
                    checked={subStageType.includes("Submitted")}
                    onChange={(e) => {
                      setSubStageType(e.target.value);
                      setPage(1);
                    }}
                  />
                  <label htmlFor="submitted" className="ml-[5px]">
                    Submitted
                  </label>
                  <div className="ml-[10px]">
                    {" "}
                    {stageType.includes("Admission")
                      ? caseStageCount?.totalAdmissionCountNew?.Submitted?.count
                      : stageType.includes("Enhancement")
                        ? caseStageCount?.totalEnhancementCountNew?.Submitted
                            ?.count
                        : stageType.includes("Discharge")
                          ? caseStageCount?.totalDischargeCountNew?.Submitted
                              ?.count
                          : stageType.includes("Claim") &&
                              !stageType.includes("Erroneous") &&
                              !stageType.includes("Reprocess")
                            ? caseStageCount?.totalClaimCountNew?.Submitted
                                ?.count
                            : stageType.includes("ClaimErroneous")
                              ? caseStageCount?.totalClaimErroneousCountNew
                                  ?.Submitted?.count
                              : stageType.includes("ClaimReprocess")
                                ? caseStageCount?.totalClaimReprocessCountNew
                                    ?.Submitted?.count
                                : caseStageCount?.overallTotalCount?.Submitted}
                  </div>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="status"
                    id="approved"
                    value={"Approved"}
                    checked={subStageType.includes("Approved")}
                    onChange={(e) => {
                      setSubStageType(e.target.value);
                      setPage(1);
                    }}
                  />
                  <label htmlFor="approved" className="ml-[5px]">
                    Approved
                  </label>
                  <div className="ml-[10px]">
                    {" "}
                    {stageType.includes("Admission")
                      ? caseStageCount?.totalAdmissionCountNew?.Approved?.count
                      : stageType.includes("Enhancement")
                        ? caseStageCount?.totalEnhancementCountNew?.Approved
                            ?.count
                        : stageType.includes("Discharge")
                          ? caseStageCount?.totalDischargeCountNew?.Approved
                              ?.count
                          : stageType.includes("Claim") &&
                              !stageType.includes("Erroneous") &&
                              !stageType.includes("Reprocess")
                            ? caseStageCount?.totalClaimCountNew?.Approved
                                ?.count
                            : stageType.includes("ClaimErroneous")
                              ? caseStageCount?.totalClaimErroneousCountNew
                                  ?.Approved?.count
                              : stageType.includes("ClaimReprocess")
                                ? caseStageCount?.totalClaimReprocessCountNew
                                    ?.Approved?.count
                                : caseStageCount?.overallTotalCount?.Approved}
                  </div>
                </div>
                <div className="flex items-center">
                  <input
                    type="radio"
                    name="status"
                    id="query"
                    value={"Query"}
                    checked={subStageType === "Query"}
                    onChange={(e) => {
                      setSubStageType(e.target.value);
                      setPage(1);
                    }}
                  />
                  <label htmlFor="query" className="ml-[5px]">
                    Query
                  </label>
                  <div className="ml-[10px]">
                    {" "}
                    {stageType.includes("Admission")
                      ? caseStageCount?.totalAdmissionCountNew?.Query?.count
                      : stageType.includes("Enhancement")
                        ? caseStageCount?.totalEnhancementCountNew?.Query?.count
                        : stageType.includes("Discharge")
                          ? caseStageCount?.totalDischargeCountNew?.Query?.count
                          : stageType.includes("Claim") &&
                              !stageType.includes("Erroneous") &&
                              !stageType.includes("Reprocess")
                            ? caseStageCount?.totalClaimCountNew?.Query?.count
                            : stageType.includes("ClaimErroneous")
                              ? caseStageCount?.totalClaimErroneousCountNew
                                  ?.Query?.count
                              : stageType.includes("ClaimReprocess")
                                ? caseStageCount?.totalClaimReprocessCountNew
                                    ?.Query?.count
                                : caseStageCount?.overallTotalCount?.Query}
                  </div>
                </div>
                {/* <div className="flex items-center">
                  <input
                    type="radio"
                    name="status"
                    id="queryResponse"
                    value={"QueryResponse"}
                    checked={subStageType.includes("QueryResponse")}
                    onChange={(e) => {
                      setSubStageType(e.target.value);
                      setPage(1);
                    }}
                  />
                  <label htmlFor="queryResponse" className="ml-[5px]">
                    High Priority Tasks
                  </label>
                  <div className="ml-[10px]">
                    {" "}
                    {stageType.includes("Admission")
                      ? caseStageCount?.totalAdmissionCountNew?.QueryResponse
                          ?.count
                      : stageType.includes("Enhancement")
                        ? caseStageCount?.totalEnhancementCountNew
                            ?.QueryResponse?.count
                        : stageType.includes("Discharge")
                          ? caseStageCount?.totalDischargeCountNew
                              ?.QueryResponse?.count
                          : stageType.includes("Claim")
                            ? caseStageCount?.totalClaimCountNew?.QueryResponse
                                ?.count
                            : caseStageCount?.overallTotalCount?.QueryResponse}
                  </div>
                </div> */}
              </div>
              <div className="flex gap-[10px] 2xl:gap-[16px] 3xl:gap-[30px] items-center">
                <div
                  className="flex items-center gap-1 text-nowrap text-white text-[12px] whitespace-nowrap px-5 py-3 bg-black rounded-full cursor-pointer "
                  onClick={() => {
                    setSubStageType("QueryResponse");
                    setPage(1);
                  }}
                >
                  <img src={HighPriorityIcon} alt="high-priority-icon" />
                  <div>High Priority</div>
                  <div className="">
                    {stageType.includes("Admission")
                      ? caseStageCount?.totalAdmissionCountNew?.QueryResponse
                          ?.count
                      : stageType.includes("Enhancement")
                        ? caseStageCount?.totalEnhancementCountNew
                            ?.QueryResponse?.count
                        : stageType.includes("Discharge")
                          ? caseStageCount?.totalDischargeCountNew
                              ?.QueryResponse?.count
                          : stageType.includes("Claim") &&
                              !stageType.includes("Erroneous") &&
                              !stageType.includes("Reprocess")
                            ? caseStageCount?.totalClaimCountNew?.QueryResponse
                                ?.count
                            : stageType.includes("ClaimErroneous")
                              ? caseStageCount?.totalClaimErroneousCountNew
                                  ?.QueryResponse?.count
                              : stageType.includes("ClaimReprocess")
                                ? caseStageCount?.totalClaimReprocessCountNew
                                    ?.QueryResponse?.count
                                : caseStageCount?.overallTotalCount
                                    ?.QueryResponse}
                  </div>
                </div>
                <div
                  style={{ border: "1px solid #017C71" }}
                  className="text-nowrap whitespace-nowrap px-5 py-3 rounded-full cursor-pointer "
                  onClick={handleClearAllClick}
                >
                  Clear All
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            border: "1px solid #FFFFFF",
          }}
          className="mt-[32px] 2xl:mt-[40px] mb-[24px] 2xl:mb-[30px]"
        />
        <div
          className={`flex items-center mb-[24px] 2xl:mb-[30px] ${
            selectedScheme.value === "TPA" ? "justify-between" : "justify-end"
          }`}
        >
          {selectedScheme.value === "TPA" && (
            <button
              type="button"
              style={{
                border: "1.5px solid #FFFFFF",
                boxShadow:
                  "0 0 0 1px rgba(1, 124, 113, 0.45), 0 1px 3px rgba(0, 0, 0, 0.12)",
              }}
              className="flex items-center justify-center gap-[10px] w-[128px] h-[40px] rounded-[35px] py-[6px] px-[20px] bg-[#FFFFFF80] text-sm text-[#191919] whitespace-nowrap cursor-pointer"
              onClick={() => setOpenAddPatientModal(true)}
            >
              <AddIcon sx={{ fontSize: 20 }} />
              Add Patient
            </button>
          )}
          <div>
            <HospitalCustomPaginaion
              page={page}
              totalPages={totalPages}
              setPage={setPage}
            />
          </div>
        </div>
        <div className="bg-[white] p-4 2xl:p-[30px] rounded-[15px]">
          <div className="grid grid-cols-[0.5fr_1.2fr_1.3fr_1fr_1.6fr_1.4fr_1fr_2fr_2fr] gap-1 text-xs 2xl:text-sm font-semibold 2xl:leading-[21.7px] -tracking-[0.03em]">
            <div>{selectedScheme?.value === "TPA" ? "Payer" : "Scheme"}</div>
            <div>
              {selectedScheme?.value === "TPA"
                ? "Policy/Claim ID"
                : "Registration ID"}
            </div>
            <div>Patient Name</div>
            <div>Age / Gender</div>
            <div className="whitespace-nowrap">
              {selectedScheme?.value === "TPA"
                ? "Registered Date"
                : "Registered Date & Time"}
            </div>
            <div>Case Stage</div>
            <div>Resolve TAT</div>
            <div className=" text-center">Action Area</div>
            <div className=""></div>
          </div>

          {loading ? (
            <div className="h-[200px] flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <div>
              {caseList?.length > 0 ? (
                caseList?.map((caseItem, idx) => {
                  return (
                    <div
                      key={idx}
                      style={{
                        background:
                          Number(getRejectedDocuments(caseItem)) > 0 ||
                          caseItem?.referenceDocumentsRejected > 0 ||
                          caseItem.submasterstagestatuses[0].hsaStage
                            .toLowerCase()
                            .includes("rejected")
                            ? "linear-gradient(90deg, #FFFFFF 2%, rgba(255, 67, 67, 0.3) 18.5%, rgba(255, 67, 67, 0.3) 81%, #FFFFFF 98%)"
                            : caseItem.submasterstagestatuses[0].hsaStage
                                  .toLowerCase()
                                  .includes("approved on tms")
                              ? "linear-gradient(90deg, #FFFFFF 0%, #B4FFCF 10.5%, #B4FFCF 88%, #FFFFFF 100%)"
                              : caseItem.submasterstagestatuses[0].hsaStage
                                    .toLowerCase()
                                    .includes("progress") ||
                                  caseItem.submasterstagestatuses[0].hsaStage
                                    .toLowerCase()
                                    .includes("submitted")
                                ? "linear-gradient(90deg, #FFFFFF 0%, rgba(237, 255, 140, 0.5) 13%, rgba(237, 255, 140, 0.5) 85%, #FFFFFF 100%)"
                                : "#FFFFFF",
                      }}
                      className="grid grid-cols-[0.5fr_1.2fr_1.3fr_1fr_1.6fr_1.4fr_1fr_2fr_2fr] gap-1 py-1 items-center mt-[8px] 2xl:mt-[10px] first:mt-6 2xl:first:mt-8 cursor-pointer"
                      onClick={() =>
                        navigate(`/dashboard/case-status/${caseItem.id}`)
                      }
                    >
                      <div className="text-xs 2xl:text-sm whitespace-nowrap text-ellipsis overflow-hidden" title={selectedScheme?.value === "TPA" ? caseItem?.payer : "PMJAY"} >
                        {selectedScheme?.value === "TPA" ? caseItem?.payer : "PMJAY"}
                      </div>
                      <div
                        className="text-[12px] 2xl:text-sm leading-[16px] 2xl:leading-[18px] overflow-hidden whitespace-nowrap text-ellipsis"
                        title={caseItem?.pmjayRegistrationId}
                      >
                        {caseItem?.pmjayRegistrationId || "--"}
                      </div>
                      <div
                        className="text-[11px] 2xl:text-xs leading-[15.66px] -tracking-[0.03em] capitalize overflow-hidden whitespace-nowrap text-ellipsis"
                        title={caseItem?.patient?.patientName}
                      >
                        <div className="text-[14px] font-medium leading-[15.66px] -tracking-[0.03em] capitalize overflow-hidden whitespace-nowrap text-ellipsis">
                          {caseItem?.patient?.patientName}
                        </div>

                        <div className="text-xs text-[#666666] -tracking-[0.5px]">
                          {caseItem?.patient?.beneficiaryNo}
                        </div>
                      </div>
                      <div className="text-[11px] 2xl:text-xs leading-[15.66px] -tracking-[3%]">
                        {caseItem?.patient?.birthDate
                          ? getFormattedAge(caseItem?.patient?.birthDate)
                          : caseItem?.patient?.age}{" "}
                        {" / "}
                        {caseItem?.patient?.gender?.[0]}
                      </div>
                      <div className="text-[12px] 2xl:text-sm leading-[18px] whitespace-nowrap">
                        {caseItem?.patient?.registeredDate
                          ? new Date(
                              caseItem?.patient?.registeredDate,
                            ).toLocaleString(
                              "en-GB",
                              selectedScheme?.value === "TPA"
                                ? {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  }
                                : {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  },
                            )
                          : "--"}
                      </div>

                      <div className=" text-[11px] 2xl:text-sm leading-[25.41px] -tracking-[3%] font-medium uppercase">
                        {caseItem.submasterstagestatuses[0].hsaStageWebText
                          ? caseItem.submasterstagestatuses[0].hsaStageWebText
                          : "--"}
                      </div>
                      <div>
                        {caseItem?.submasterstagestatuses?.[0]?.deadline ? (
                          <CountdownTimer
                            targetDate={
                              caseItem?.submasterstagestatuses?.[0]?.deadline
                            }
                          />
                        ) : (
                          "--"
                        )}
                      </div>
                      {stageUpdating === caseItem?.id ? (
                        <div className=" flex justify-center">
                          <CircularProgress sx={{ color: "#000000" }} />
                        </div>
                      ) : (
                        <div
                          className=" flex justify-center"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {Number(getRejectedDocuments(caseItem)) > 0 ? (
                            <Link
                              to={`/dashboard/case-status/${caseItem.id}`}
                              style={{ border: "1px solid #FF8282" }}
                              className="no-underline text-white bg-[#FF8282] shadow-md rounded-full px-3 2xl:px-4 py-2 2xl:py-3"
                            >
                              <div className="text-[10px] 2xl:text-sm -tracking-[3%] cursor-pointer">
                                {`${getRejectedDocuments(
                                  caseItem,
                                )} REJECTED DOCUMENT`}
                              </div>
                            </Link>
                          ) : caseItem?.submasterstagestatuses[0].hsaStage
                              .toLowerCase()
                              .includes("request to admission") ? (
                            <div
                              className="uppercase w-fit text-[10px] 2xl:text-xs text-white bg-[#017C71] -tracking-[3%] shadow-xl rounded-full py-3 xl:px-4 2xl:px-9 cursor-pointer"
                              onClick={() => handleInitiateAdmission(caseItem)}
                            >
                              Initiate Admission
                            </div>
                          ) : caseItem?.submasterstagestatuses[0].hsaStage
                              .toLowerCase()
                              .includes("admission approved on tms") ||
                            caseItem?.submasterstagestatuses[0].hsaStage
                              .toLowerCase()
                              .includes("enhancement approved on tms") ||
                            caseItem?.submasterstagestatuses[0].hsaStage
                              .toLowerCase()
                              .includes("enhancement rejected") ? (
                            caseItem.caseSubType === "DIALYSIS" ? (
                              <div
                                className="text-[12px] font-medium leading-[155%] tracking-[-0.07em] text-white bg-[#017C71] py-4 px-6 rounded-full cursor-pointer"
                                onClick={() => {
                                  setSelectedCase(caseItem);
                                  handleOutTimeStageUpdate(caseItem);
                                }}
                              >
                                DIALYSIS ON OUT
                              </div>
                            ) : (
                              <Accordion
                                expanded={caseItem.id === expanded.id}
                                style={{
                                  width:
                                    window.innerWidth < 1444 ? "100%" : "80%",
                                  borderRadius:
                                    caseItem.id === expanded.id
                                      ? "25px"
                                      : "100px",
                                }}
                              >
                                <AccordionSummary
                                  expandIcon={
                                    <ExpandMoreIcon
                                      style={{
                                        color:
                                          caseItem.id === expanded.id
                                            ? "#000000"
                                            : "#ffffff",
                                      }}
                                    />
                                  }
                                  style={{
                                    background:
                                      caseItem.id === expanded.id
                                        ? "#FFFFFF"
                                        : "#017C71",
                                    borderRadius:
                                      caseItem.id === expanded.id
                                        ? "25px"
                                        : "100px",
                                    color:
                                      caseItem.id === expanded.id
                                        ? "#000000"
                                        : "#ffffff",
                                    fontSize:
                                      window.innerWidth < 1444
                                        ? "12px"
                                        : "14px",
                                  }}
                                  onClick={() => {
                                    caseItem.id === expanded.id
                                      ? setExpanded({ ...expanded, id: "" })
                                      : setExpanded({
                                          ...expanded,
                                          id: caseItem.id,
                                        });
                                  }}
                                >
                                  INITIATE
                                </AccordionSummary>
                                <AccordionDetails
                                  style={{
                                    fontSize: "12px",
                                    letterSpacing: "-3%",
                                  }}
                                >
                                  <div
                                    className="text-white bg-[#017C71] rounded-full py-3 text-center text-[11px] 2xl:text-[12px] cursor-pointer -mt-1.5"
                                    onClick={() => {
                                      setAddDischarge(true);
                                      setSelectedCase(caseItem);
                                    }}
                                  >
                                    INITIATE DISCHARGE
                                  </div>
                                  <div
                                    className="text-white bg-[#017C71] rounded-full py-3 text-center text-[11px] 2xl:text-[12px] cursor-pointer mt-1"
                                    onClick={() =>
                                      handleInitiateEnhancement(caseItem)
                                    }
                                  >
                                    {caseItem.submasterstagestatuses[0].hsaStage
                                      .toLowerCase()
                                      .includes("enhancement rejected")
                                      ? "RE-INITIATE ENHANCEMENT"
                                      : "INITIATE ENHANCEMENT"}
                                  </div>
                                </AccordionDetails>
                              </Accordion>
                            )
                          ) : caseItem?.submasterstagestatuses[0].hsaStage
                              .toLowerCase()
                              .includes("dialysis on out") ? (
                            <Accordion
                              expanded={caseItem.id === expanded.id}
                              style={{
                                width:
                                  window.innerWidth < 1444 ? "100%" : "80%",
                                borderRadius:
                                  caseItem.id === expanded.id
                                    ? "25px"
                                    : "100px",
                              }}
                            >
                              <AccordionSummary
                                expandIcon={
                                  <ExpandMoreIcon
                                    style={{
                                      color:
                                        caseItem.id === expanded.id
                                          ? "#000000"
                                          : "#ffffff",
                                    }}
                                  />
                                }
                                style={{
                                  background:
                                    caseItem.id === expanded.id
                                      ? "#FFFFFF"
                                      : "#017C71",
                                  borderRadius:
                                    caseItem.id === expanded.id
                                      ? "25px"
                                      : "100px",
                                  color:
                                    caseItem.id === expanded.id
                                      ? "#000000"
                                      : "#ffffff",
                                  fontSize:
                                    window.innerWidth < 1444 ? "12px" : "14px",
                                }}
                                onClick={() => {
                                  caseItem.id === expanded.id
                                    ? setExpanded({ ...expanded, id: "" })
                                    : setExpanded({
                                        ...expanded,
                                        id: caseItem.id,
                                      });
                                }}
                              >
                                INITIATE
                              </AccordionSummary>
                              <AccordionDetails
                                style={{
                                  fontSize: "12px",
                                  letterSpacing: "-3%",
                                }}
                              >
                                <div
                                  className="text-white bg-[#017C71] rounded-full py-3 text-center text-[11px] 2xl:text-[12px] cursor-pointer -mt-1.5"
                                  onClick={() => {
                                    setAddDischarge(true);
                                    setSelectedCase(caseItem);
                                  }}
                                >
                                  INITIATE DISCHARGE
                                </div>
                                <div
                                  className="text-white bg-[#017C71] rounded-full py-3 text-center text-[11px] 2xl:text-[12px] cursor-pointer mt-1"
                                  onClick={() =>
                                    handleInitiateEnhancement(caseItem)
                                  }
                                >
                                  {caseItem.submasterstagestatuses[0].hsaStage
                                    .toLowerCase()
                                    .includes("enhancement rejected")
                                    ? "RE-INITIATE ENHANCEMENT"
                                    : "INITIATE ENHANCEMENT"}
                                </div>
                              </AccordionDetails>
                            </Accordion>
                          ) : (
                            ""
                          )}
                        </div>
                      )}

                      <div className=" flex items-center justify-end">
                        <div style={{ width: "46px" }}>
                          <CircularProgressbarWithChildren
                            value={calculatePrcentage(
                              Number(getTotalDocuments(caseItem)) -
                                Number(getPendingDocuments(caseItem)),
                              Number(getTotalDocuments(caseItem)),
                            )}
                            strokeWidth={13}
                            styles={{
                              path: {
                                stroke: "#000",
                                strokeLinecap: "round",
                                transformOrigin: "center center",
                              },
                              trail: {
                                stroke: "#E8E8E8",
                                transformOrigin: "center center",
                              },
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                                fontSize: "10px",
                                color: "#000",
                                fontFamily: "inter, sans-serif",
                                fontWeight: 500,
                              }}
                            >
                              {Number(getTotalDocuments(caseItem)) -
                                Number(getPendingDocuments(caseItem))}
                              /{Number(getTotalDocuments(caseItem))}
                            </div>
                          </CircularProgressbarWithChildren>
                        </div>
                        <div className="w-[43px] h-[43px] flex items-center justify-center cursor-pointer hidden">
                          <img src={CallIcon} alt="call-icon" />
                        </div>
                        <Link to={`/dashboard/case-status/${caseItem.id}`}>
                          <div className="group relative w-[43px] h-[43px] flex items-center justify-center cursor-pointer">
                            <img src={ChatIcon} alt="chat-icon" />
                            {caseItem?.totalUnreadComments > 0 && (
                              <div className="absolute top-1 right-2 w-[16px] h-[16px] flex justify-center items-center text-[10px] text-white bg-[#FF4343] rounded-full">
                                {caseItem?.totalUnreadComments > 99
                                  ? "99+"
                                  : caseItem.totalUnreadComments}
                              </div>
                            )}
                            <div className="absolute -bottom-2 left-0 group-hover:block hidden text-[10px] text-white text-nowrap bg-[#191919] p-1 rounded-[4px]">
                              AI Commments
                            </div>
                          </div>
                        </Link>

                        <div
                          style={{
                            visibility:
                              caseItem?.submasterstagestatuses[0].hsaStage
                                .toLowerCase()
                                .includes("request to admission")
                                ? "hidden"
                                : "visible",
                          }}
                          className="relative group w-[43px] h-[43px] flex items-center justify-center cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedCase(caseItem);
                            setOpenReferenceModal(true);
                          }}
                        >
                          <img
                            src={
                              caseItem?.referenceDocumentsRejected
                                ? ReferenceRejected
                                : UploadIcon
                            }
                            alt="upload-icon"
                            className={`${
                              caseItem?.referenceDocumentsRejected
                                ? "h-[28px] w-[28px]"
                                : ""
                            }`}
                          />
                          {caseItem?.refDocUnreadComments > 0 && (
                            <div className="absolute top-1 right-1 w-[16px] h-[16px] flex justify-center items-center text-[10px] text-white bg-[#FF4343] rounded-full">
                              {caseItem?.refDocUnreadComments > 99
                                ? "99+"
                                : caseItem.refDocUnreadComments}
                            </div>
                          )}
                          <div className="absolute -bottom-3 left-0 group-hover:block hidden text-[10px] text-white text-nowrap bg-[#191919] p-1 rounded-[4px]">
                            Reference Documents
                          </div>
                        </div>

                        <div className="group relative">
                          {caseItem?.caseprocedures?.find(
                            (procedure) => procedure?.procedureFromHospital,
                          ) ? (
                            <img
                              src={RiskIcon}
                              alt="risk-icon"
                              height={28}
                              width={28}
                            />
                          ) : (
                            <div className="w-7 h-7" />
                          )}
                          {caseItem?.riskData && (
                            <div className="absolute -bottom-5 right-0 group-hover:block hidden text-[10px] text-white text-nowrap bg-[#191919] p-1 rounded-[4px]">
                              {Object?.keys(caseItem?.riskData).map((key) => (
                                <div
                                  key={caseItem?.riskData[key].id}
                                  className="mb-1"
                                >
                                  {caseItem?.riskData[key].message}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="h-[200px] flex justify-center items-center font-semibold text-xl">
                  No Case Data Found
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {openReferenceModal && (
        <HospitalReferenceDocument
          selectedCase={selectedCase}
          setOpen={setOpenReferenceModal}
          AllCases={refreshDashboardData}
        />
      )}
      {openInitiateReferenceModal && (
        <UploadAdmissionInitiateRefDoc
          selectedCase={selectedCase}
          selectedScheme={selectedScheme}
          setOpen={setOpenInitiateReferenceModal}
          AllCases={refreshDashboardData}
          caseType={caseType}
          stayDuration={stayDuration}
          stratification={stratification}
          subType={subType}
          admissionDate={admissionDate}
          surgeryTreatmentStartDate={surgeryTreatmentStartDate}
          subTypeOptions={subTypeOptions}
        />
      )}
      {referenceNotUploaded && (
        <ReferenceNotUploadedModal
          setReferenceNotUploaded={setReferenceNotUploaded}
          setOpenInitiateReferenceModal={setOpenInitiateReferenceModal}
          referenceNotUploaded={referenceNotUploaded}
          selectedScheme={selectedScheme}
          caseType={caseType}
          setCaseType={setCaseType}
          stayDuration={stayDuration}
          setStayDuration={setStayDuration}
          stratification={stratification}
          setStratification={setStratification}
          subType={subType}
          setSubType={setSubType}
          admissionDate={admissionDate}
          setAdmissionDate={setAdmissionDate}
          surgeryTreatmentStartDate={surgeryTreatmentStartDate}
          setSurgeryTreatmentStartDate={setSurgeryTreatmentStartDate}
          subTypeOptions={subTypeOptions}
          setSubTypeOptions={setSubTypeOptions}
        />
      )}
      {openAddPatientModal && selectedScheme.value === "TPA" && (
        <AddPatientModal
          onClose={() => setOpenAddPatientModal(false)}
          files={addPatientFiles}
          setFiles={setAddPatientFiles}
          AllCases={refreshDashboardData}
        />
      )}
      {openOutTimeModal && selectedCase && (
        <OutTimeModal
          setOpen={setOpenOutTimeModal}
          selectedCase={selectedCase}
          AllCases={refreshDashboardData}
          setOpenEnhancement={setAddEnhancement}
          setOpenDischarge={setAddDischarge}
          handleInitiateEnhancement={handleInitiateEnhancement}
        />
      )}
      {addEnhancement && selectedCase ? (
        selectedScheme?.value === "TPA" ? (
          <TpaEnhancementFormHospitalPersona
            enhancementList={selectedCase.enhancements}
            setAddEnhancement={setAddEnhancement}
            caseDetails={selectedCase}
            caseId={selectedCase.id}
            admissionDate={selectedCase.admissionDate}
            onContinueToUpload={(values) => {
              setTpaEnhancementFormData(values);
              setAddEnhancement(false);
              setOpenTpaEnhancementUpload(true);
            }}
          />
        ) : selectedCase?.caseSubType === "DIALYSIS" ? (
          <DialysisEnhancementFormHospitalPersona
            totalPackageCost={selectedCase.totalPackageCost}
            caseProcedures={selectedCase.procedures}
            enhancementList={selectedCase.enhancements}
            setAddEnhancement={setAddEnhancement}
            caseDetails={selectedCase}
            caseId={selectedCase.id}
            admissionDate={selectedCase.admissionDate}
            currentSubMasterStageId={selectedCase?.currentSubMasterStageId}
            AllCases={refreshDashboardData}
          />
        ) : (
          <EnhancementFormHospitalPersona
            totalPackageCost={selectedCase.totalPackageCost}
            caseProcedures={selectedCase.procedures}
            enhancementList={selectedCase.enhancements}
            setAddEnhancement={setAddEnhancement}
            caseDetails={selectedCase}
            caseId={selectedCase.id}
            admissionDate={selectedCase.admissionDate}
            currentSubMasterStageId={selectedCase?.currentSubMasterStageId}
            AllCases={refreshDashboardData}
          />
        )
      ) : (
        ""
      )}

      {openTpaEnhancementUpload && selectedCase && (
        <TpaUploadReferenceDocModal
          setOpen={(open) => {
            setOpenTpaEnhancementUpload(open);
            if (!open) setTpaEnhancementFormData(null);
          }}
          selectedCase={selectedCase}
          AllCases={refreshDashboardData}
          flowType="ENHANCEMENT"
          formData={tpaEnhancementFormData}
        />
      )}

      {addDischarge && selectedCase && (
        selectedScheme?.value === "TPA" ? (
          <TpaDischargeFormHospitalPersona
            caseId={selectedCase.id}
            setAddDischarge={setAddDischarge}
            onContinueToUpload={(values) => {
              setTpaDischargeFormData(values);
              setAddDischarge(false);
              setOpenTpaDischargeUpload(true);
            }}
          />
        ) : (
          <DischargeFormHospitalPersona
            caseId={selectedCase.id}
            setAddDischarge={setAddDischarge}
            currentSubMasterStageId={selectedCase?.currentSubMasterStageId}
            AllCases={refreshDashboardData}
          />
        )
      )}

      {openTpaDischargeUpload && selectedCase && (
        <TpaUploadReferenceDocModal
          setOpen={(open) => {
            setOpenTpaDischargeUpload(open);
            if (!open) setTpaDischargeFormData(null);
          }}
          selectedCase={selectedCase}
          AllCases={refreshDashboardData}
          flowType="DISCHARGE"
          formData={tpaDischargeFormData}
        />
      )}
    </div>
  );
};

export default CaseStatus;
